import { TrackedKeywordsGroupedByCategoryWidget } from '@modules/feed/components/TrackedKeywordsGroupedByCategoryWidget';
import { Box, Grid } from '@mui/material';
import { SourceDistributionWidget } from '../SourceDistributionWidget';
import { TrendingReasonsWidget } from '../TrendingReasonsWidget';

export function SearchAnalysesReportWidgets() {
  // Box is required to avoid overriding of Grid container margin
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item key="stats" xs={4}>
          <TrackedKeywordsGroupedByCategoryWidget />
        </Grid>
        <Grid item key="reason-widget" xs={4}>
          <TrendingReasonsWidget />
        </Grid>
        <Grid item key="source-widget" xs={4}>
          <SourceDistributionWidget />
        </Grid>
      </Grid>
    </Box>
  );
}
